
import { Component, OnInit } from '@angular/core';
import { Globals } from 'app/_globals';

@Component({
  selector: 'admin-manage-types',
  templateUrl: './admin-manage-types.component.html'
})
export class AdminManageTypesComponent implements OnInit {

  public routeRole;

  constructor(
    public globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
  }
}
